import { Link } from 'react-router-dom';
import { Send, Facebook, Instagram, Youtube, Music } from 'lucide-react';

export default function Footer() {
    return (
        <footer className="bg-emerald-900 text-white">
            <div className="container mx-auto px-4 py-12">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
                    <div>
                        <div className="flex items-center space-x-2 mb-4">
                            <div>
                                <img src='./logo.png' className='w-12 h-12' />
                            </div>
                            <div>
                                <p className='text-3xl font-bold text-white leading-none'>MOJO</p>
                                <p className='text-lg font-bold text-white leading-none'>MONEY</p>

                            </div>
                        </div>
                        <p className="text-emerald-100">
                            Fast, secure, and reliable money transfer services for the Ethiopian diaspora community.
                        </p>
                    </div>

                    <div>
                        <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
                        <ul className="space-y-2">
                            <li><Link to="/" className="text-emerald-100 hover:text-yellow-500 transition">Home</Link></li>
                            <li><Link to="/features" className="text-emerald-100 hover:text-yellow-500 transition">Features</Link></li>
                            <li><Link to="/exchange-rates" className="text-emerald-100 hover:text-yellow-500 transition">Exchange Rates</Link></li>
                            <li><Link to="/about" className="text-emerald-100 hover:text-yellow-500 transition">About Us</Link></li>
                        </ul>
                    </div>

                    <div>
                        <h3 className="text-lg font-semibold mb-4">Services</h3>
                        <ul className="space-y-2">
                            <li><Link to="/banks" className="text-emerald-100 hover:text-yellow-500 transition">Partner Banks</Link></li>
                            <li><Link to="/merchants" className="text-emerald-100 hover:text-yellow-500 transition">Merchants</Link></li>
                            <li><Link to="/campaigns" className="text-emerald-100 hover:text-yellow-500 transition">Campaigns</Link></li>
                            <li><Link to="/faq" className="text-emerald-100 hover:text-yellow-500 transition">FAQ</Link></li>
                            <li><Link to="/privacy-policy" className="text-emerald-100 hover:text-yellow-500 transition">Privacy Policy</Link></li>
                            <li><Link to="/terms-and-conditions" className="text-emerald-100 hover:text-yellow-500 transition">Terms & Conditions</Link></li>


                        </ul>
                    </div>

                    <div>
                        <h3 className="text-lg font-semibold mb-4">Connect With Us</h3>
                        <div className="flex space-x-4 mb-4">
                            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-emerald-100 hover:text-yellow-500 transition">
                                <Facebook className="w-6 h-6" />
                            </a>
                            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-emerald-100 hover:text-yellow-500 transition">
                                <Instagram className="w-6 h-6" />
                            </a>
                            <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="text-emerald-100 hover:text-yellow-500 transition">
                                <Youtube className="w-6 h-6" />
                            </a>
                            <a href="https://tiktok.com" target="_blank" rel="noopener noreferrer" className="text-emerald-100 hover:text-yellow-500 transition">
                                <Music className="w-6 h-6" />
                            </a>
                        </div>
                        <Link to="/contact" className="inline-block bg-yellow-500 text-emerald-900 px-6 py-2 rounded-lg font-semibold hover:bg-yellow-400 transition">
                            Contact Us
                        </Link>
                    </div>
                </div>

                <div className="border-t border-emerald-800 mt-8 pt-8 text-center text-emerald-100">
                    <p>&copy; 2025 Mojo Money. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
}
